export const italianFlashcards = {
  categories: [
    {
      it: "Ciao",
      rm: "Chao",
      en: "Hello / Hi / Bye (informal)",
    },
    {
      it: "Buongiorno",
      rm: "Bwon-jor-no",
      en: "Good morning / Good day",
    },
    {
      it: "Buonasera",
      rm: "Bwo-na-seh-ra",
      en: "Good evening",
    },
    {
      it: "Buonanotte",
      rm: "Bwo-na-not-teh",
      en: "Good night",
    },
    {
      it: "Arrivederci",
      rm: "Ar-ree-veh-dehr-chee",
      en: "Goodbye (formal)",
    },
    {
      it: "A presto",
      rm: "Ah press-toh",
      en: "See you soon",
    },
    {
      it: "Per favore",
      rm: "Per fa-vo-reh",
      en: "Please",
    },
    {
      it: "Grazie",
      rm: "Gra-tzee-eh",
      en: "Thank you",
    },
    {
      it: "Grazie mille",
      rm: "Gra-tzee-eh mee-lleh",
      en: "Thank you very much",
    },
    {
      it: "Prego",
      rm: "Preh-go",
      en: "You're welcome / Please / Here you are",
    },
    {
      it: "Scusi",
      rm: "Skoo-zee",
      en: "Excuse me / Sorry (formal)",
    },
    {
      it: "Scusa",
      rm: "Skoo-za",
      en: "Excuse me / Sorry (informal)",
    },
    {
      it: "Sì",
      rm: "See",
      en: "Yes",
    },
    {
      it: "No",
      rm: "No",
      en: "No",
    },
    {
      it: "Va bene",
      rm: "Va beh-neh",
      en: "Okay / Alright",
    },
    {
      it: "Non capisco",
      rm: "Non ka-pees-ko",
      en: "I don't understand",
    },
    {
      it: "Parla inglese?",
      rm: "Par-la een-gleh-zeh?",
      en: "Do you speak English? (formal)",
    },
    {
      it: "Parli inglese?",
      rm: "Par-lee een-gleh-zeh?",
      en: "Do you speak English? (informal)",
    },
    {
      it: "Come sta?",
      rm: "Ko-meh sta?",
      en: "How are you? (formal)",
    },
    {
      it: "Come stai?",
      rm: "Ko-meh stai?",
      en: "How are you? (informal)",
    },
    {
      it: "Come va?",
      rm: "Ko-meh va?",
      en: "How's it going?",
    },
    {
      it: "Bene, grazie",
      rm: "Beh-neh, gra-tzee-eh",
      en: "Fine, thank you",
    },
    {
      it: "Come si chiama?",
      rm: "Ko-meh see kee-ah-ma?",
      en: "What's your name? (formal)",
    },
    {
      it: "Come ti chiami?",
      rm: "Ko-meh tee kee-ah-mee?",
      en: "What's your name? (informal)",
    },
    {
      it: "Mi chiamo...",
      rm: "Mee kee-ah-mo...",
      en: "My name is...",
    },
    {
      it: "Dov'è...?",
      rm: "Doh-veh...?",
      en: "Where is...?",
    },
    {
      it: "Dov'è il bagno?",
      rm: "Doh-veh eel ban-yo?",
      en: "Where is the bathroom?",
    },
    {
      it: "Dov'è la stazione?",
      rm: "Doh-veh la stat-tzee-o-neh?",
      en: "Where is the train station?",
    },
    {
      it: "Dov'è l'aeroporto?",
      rm: "Doh-veh lah-eh-ro-por-to?",
      en: "Where is the airport?",
    },
    {
      it: "Quanto costa?",
      rm: "Kwan-to kos-ta?",
      en: "How much does it cost?",
    },
    {
      it: "È troppo caro",
      rm: "Eh trop-po ka-ro",
      en: "It's too expensive",
    },
    {
      it: "Aiuto!",
      rm: "Ah-yoo-to!",
      en: "Help!",
    },
    {
      it: "Ho bisogno di aiuto",
      rm: "O bee-zo-nyo dee ah-yoo-to",
      en: "I need help",
    },
    {
      it: "Mi sono perso/a",
      rm: "Mee so-no per-so (m) / per-sa (f)",
      en: "I am lost (male/female)",
    },
    {
      it: "Cerco...",
      rm: "Cher-ko...",
      en: "I'm looking for...",
    },
    {
      it: "Vorrei...",
      rm: "Vor-rei...",
      en: "I would like...",
    },
    {
      it: "Voglio...",
      rm: "Vol-yo...",
      en: "I want...",
    },
    {
      it: "Un caffè, per favore",
      rm: "Oon kaf-feh, per fa-vo-reh",
      en: "A coffee, please",
    },
    {
      it: "Il conto, per favore",
      rm: "Eel kon-to, per fa-vo-reh",
      en: "The bill, please",
    },
    {
      it: "Sono vegetariano/a",
      rm: "So-no veh-jeh-tah-ree-ah-no (m) / veh-jeh-tah-ree-ah-na (f)",
      en: "I am vegetarian (male/female)",
    },
    {
      it: "Sono allergico/a a...",
      rm: "So-no al-ler-jee-ko (m) / al-ler-jee-ka (f) ah...",
      en: "I am allergic to...",
    },
    {
      it: "È delizioso",
      rm: "Eh deh-lee-tzee-o-zo",
      en: "It's delicious",
    },
    {
      it: "Salute!",
      rm: "Sa-loo-teh!",
      en: "Cheers!",
    },
    {
      it: "Non mi sento bene",
      rm: "Non mee sen-to beh-neh",
      en: "I don't feel well",
    },
    {
      it: "Dov'è l'ospedale?",
      rm: "Doh-veh los-peh-dah-leh?",
      en: "Where is the hospital?",
    },
    {
      it: "Parlo un po' d'italiano",
      rm: "Par-lo oon po dee-tah-lee-ah-no",
      en: "I speak a little Italian",
    },
    {
      it: "Più lentamente, per favore",
      rm: "Pee-oo len-tah-men-teh, per fa-vo-reh",
      en: "More slowly, please",
    },
    {
      it: "Può ripetere, per favore?",
      rm: "Pwo ree-peh-teh-reh, per fa-vo-reh?",
      en: "Can you repeat that, please?",
    },
    {
      it: "Sono stanco/a",
      rm: "So-no stan-ko (m) / stan-ka (f)",
      en: "I am tired (male/female)",
    },
    {
      it: "Che tempo fa?",
      rm: "Keh tem-po fa?",
      en: "What's the weather like?",
    },
    {
      it: "Fa bel tempo",
      rm: "Fa bel tem-po",
      en: "The weather is nice",
    },
    {
      it: "Fa caldo",
      rm: "Fa kal-do",
      en: "It's hot",
    },
    {
      it: "Fa freddo",
      rm: "Fa fred-do",
      en: "It's cold",
    },
    {
      it: "Piove",
      rm: "Pee-o-veh",
      en: "It's raining",
    },
    {
      it: "D'accordo",
      rm: "Dahk-kor-do",
      en: "Agreed / Okay",
    },
    {
      it: "Non sono d'accordo",
      rm: "Non so-no dahk-kor-do",
      en: "I disagree",
    },
    {
      it: "È interessante",
      rm: "Eh een-teh-ress-san-teh",
      en: "It's interesting",
    },
    {
      it: "È importante",
      rm: "Eh eem-por-tan-teh",
      en: "It's important",
    },
    {
      it: "È possibile",
      rm: "Eh pos-see-bee-leh",
      en: "It's possible",
    },
    {
      it: "È impossibile",
      rm: "Eh eem-pos-see-bee-leh",
      en: "It's impossible",
    },
    {
      it: "Che ore sono?",
      rm: "Keh o-reh so-no?",
      en: "What time is it?",
    },
    {
      it: "Oggi",
      rm: "Od-jee",
      en: "Today",
    },
    {
      it: "Domani",
      rm: "Do-mah-nee",
      en: "Tomorrow",
    },
    {
      it: "Ieri",
      rm: "Yeh-ree",
      en: "Yesterday",
    },
    {
      it: "Adesso",
      rm: "Ah-dess-so",
      en: "Now",
    },
    {
      it: "Più tardi",
      rm: "Pee-oo tar-dee",
      en: "Later",
    },
    {
      it: "A destra",
      rm: "Ah dess-tra",
      en: "To the right",
    },
    {
      it: "A sinistra",
      rm: "Ah see-nees-tra",
      en: "To the left",
    },
    {
      it: "Dritto",
      rm: "Dreet-to",
      en: "Straight ahead",
    },
    {
      it: "Vicino",
      rm: "Vee-chee-no",
      en: "Near",
    },
    {
      it: "Lontano",
      rm: "Lon-ta-no",
      en: "Far",
    },
    {
      it: "Sono perso/a",
      rm: "So-no per-so (m) / per-sa (f)",
      en: "I'm lost (male/female)",
    },
    {
      it: "Non sto bene",
      rm: "Non sto beh-neh",
      en: "I don't feel well",
    },
    {
      it: "È urgente",
      rm: "Eh oor-jen-teh",
      en: "It's urgent",
    },
    {
      it: "Un momento, per favore",
      rm: "Oon mo-men-to, per fa-vo-reh",
      en: "One moment, please",
    },
    {
      it: "Non lo so",
      rm: "Non lo so",
      en: "I don't know",
    },
    {
      it: "Va tutto bene",
      rm: "Va toot-to beh-neh",
      en: "Everything is alright",
    },
    {
      it: "Non importa",
      rm: "Non eem-por-ta",
      en: "It doesn't matter",
    },
    {
      it: "Nessun problema",
      rm: "Ness-soon pro-bleh-ma",
      en: "No problem",
    },
    {
      it: "Attenzione!",
      rm: "At-ten-tzee-o-neh!",
      en: "Be careful!",
    },
    {
      it: "Lasciami in pace",
      rm: "Lah-shee-ah-mee een pa-cheh",
      en: "Leave me alone",
    },
    {
      it: "Ho fame",
      rm: "O fa-meh",
      en: "I'm hungry",
    },
    {
      it: "Ho sete",
      rm: "O seh-teh",
      en: "I'm thirsty",
    },
    {
      it: "Mi dispiace",
      rm: "Mee dee-spee-ah-cheh",
      en: "I'm sorry",
    },
    {
      it: "Congratulazioni!",
      rm: "Kon-gra-too-lat-zee-o-nee!",
      en: "Congratulations!",
    },
    {
      it: "Buona fortuna!",
      rm: "Bwo-na for-too-na!",
      en: "Good luck!",
    },
    {
      it: "Buon viaggio!",
      rm: "Bwon vee-ah-jo!",
      en: "Have a good trip!",
    },
    {
      it: "Cin cin!",
      rm: "Cheen cheen!",
      en: "Cheers!",
    },
    {
      it: "È gratis?",
      rm: "Eh grah-tees?",
      en: "Is it free?",
    },
    {
      it: "Qual è la password del Wi-Fi?",
      rm: "Kwal eh la pass-word del Wi-Fi?",
      en: "What's the Wi-Fi password?",
    },
    {
      it: "Posso fare una foto?",
      rm: "Pos-so fa-reh oo-na fo-to?",
      en: "Can I take a picture?",
    },
  ],
};
